import React from 'react';
import $ from '../../common/AjaxRequest';
import { Modal, Spin, Checkbox,message } from 'antd';
import API_URL from '../../common/url';

class ConfigColumn extends React.Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        checkBoxArr: {},
        selectAll: false,
    }

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            checkBoxArr: {},
        });
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvCustomDisplay,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { userId, investigationCustomDisplayId, ...checkBoxArr } = res.success || {};
                const selectAll = Object.keys(checkBoxArr).every(key => {
                    if (key !== 'investigationIdentifyCode' && key !== 'investigationName' && key !== 'investigationCode' && key !== 'investigationStatus') {
                        return checkBoxArr[key] == 1;
                    } else {
                        return true;
                    }
                });
                for (const key in checkBoxArr) {
                    if (checkBoxArr[key] == '') {
                        checkBoxArr[key] = '0';
                    }
                };
                this.setState({
                    selectAll,
                    checkBoxArr,
                    loading: false,
                    data: { userId, investigationCustomDisplayId }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleSubmit = () => {
        const { data, checkBoxArr } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.configInvCustomDisplay,
            data: {
                ...data,
                ...checkBoxArr,
                investigationIdentifyCode: 1,
                investigationName: 1,
                investigationCode: 1,
                investigationStatus: 0,
            },
            dataType: 'json',
            doneResult: () => {
                message.success('保存成功');
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.getHeader();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    onCheckChange = (e ,key) => {
        const { checkBoxArr } = this.state;
        checkBoxArr[key] = e.target.checked ? 1 : 0;
        this.setState({ checkBoxArr });
    }

    handleSelectAll = (e) => {
        const { checkBoxArr } = this.state;
        const selectAll = e.target.checked;
        Object.keys(checkBoxArr).forEach(key => {
            if (key !== 'investigationName' && key !== 'investigationCode' && key !== 'investigationStatus' && key !== 'investigationIdentifyCode') {
                checkBoxArr[key] = selectAll ? 1 : 0;
            }
        });
        this.setState({ checkBoxArr, selectAll });
    }

    render() {
        const { visible, loading, checkBoxArr, selectAll } = this.state;
        return (
            <Modal
                title="自定义显示列"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="condition-modal"
                wrapClassName="vertical-center-modal"
                width="650px"
                loading={loading}
            >
                <Spin spinning={loading}>
                    <div>
                        <Checkbox checked={selectAll} onChange={this.handleSelectAll}>全选</Checkbox>
                        <div className="con-options config_column">
                            <Checkbox checked={checkBoxArr["investigationIdentifyCode"] == 1} disabled onChange={(e) => this.onCheckChange(e,"investigationIdentifyCode")}>项目识别码</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationName"] == 1} disabled onChange={(e) => this.onCheckChange(e,"investigationName")}>项目简称</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationSpecialName"] == 1} onChange={(e) => this.onCheckChange(e,"investigationSpecialName")}>项目名称</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationCode"] == 1} disabled onChange={(e) => this.onCheckChange(e,"investigationCode")}>项目编号</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationJdeContractCode"] == 1} onChange={(e) => this.onCheckChange(e,"investigationJdeContractCode")}>JDE主项目号</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationGlobalType"] == 1} onChange={(e) => this.onCheckChange(e,"investigationGlobalType")}>项目类型</Checkbox>
                            <Checkbox checked={checkBoxArr["levelName"] == 1} onChange={(e) => this.onCheckChange(e,"levelName")}>项目级别</Checkbox>
                            <Checkbox checked={checkBoxArr["invStatus"] == 1} onChange={(e) => this.onCheckChange(e,"invStatus")}>项目状态</Checkbox>
                            <Checkbox checked={checkBoxArr["stageName"] == 1} onChange={(e) => this.onCheckChange(e,"stageName")}>项目阶段</Checkbox>
                            <Checkbox checked={checkBoxArr["terminationTime"] == 1} onChange={(e) => this.onCheckChange(e,"terminationTime")}>暂停/终止时间</Checkbox>
                            <Checkbox checked={checkBoxArr["siteStartState"] == 1} onChange={(e) => this.onCheckChange(e,"siteStartState")}>中心启动情况</Checkbox>
                            <Checkbox checked={checkBoxArr["typeName"] == 1} onChange={(e) => this.onCheckChange(e,"typeName")}>项目分类</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationAreaName"] == 1} onChange={(e) => this.onCheckChange(e,"investigationAreaName")}>项目领域</Checkbox>
                            <Checkbox checked={checkBoxArr["diseaseClassName"] == 1} onChange={(e) => this.onCheckChange(e,"diseaseClassName")}>疾病分类</Checkbox>
                            <Checkbox checked={checkBoxArr["diseaseName"] == 1} onChange={(e) => this.onCheckChange(e,"diseaseName")}>疾病</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationMedicineName"] == 1} onChange={(e) => this.onCheckChange(e,"investigationMedicineName")}>研究产品类型</Checkbox>
                            <Checkbox checked={checkBoxArr["treatmentMethod"] == 1} onChange={(e) => this.onCheckChange(e,"treatmentMethod")}>治疗方式</Checkbox>
                            <Checkbox checked={checkBoxArr["drugMainTargets"] == 1} onChange={(e) => this.onCheckChange(e,"drugMainTargets")}>药物(疗法)分类<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/主要作用靶点</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationMedicine"] == 1} onChange={(e) => this.onCheckChange(e,"investigationMedicine")}>研究药物通用名称<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/产品具体名称/技术名称</Checkbox>
                            <Checkbox checked={checkBoxArr["administrationMode"] == 1} onChange={(e) => this.onCheckChange(e,"administrationMode")}>给药方式</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationByStageName"] == 1} onChange={(e) => this.onCheckChange(e,"investigationByStageName")}>项目分期</Checkbox>
                            <Checkbox checked={checkBoxArr["testeeTypeId"] == 1} onChange={(e) => this.onCheckChange(e,"testeeTypeId")}>受试者类型</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationSponsor"] == 1} onChange={(e) => this.onCheckChange(e,"investigationSponsor")}>申办方</Checkbox>
                            <Checkbox checked={checkBoxArr["cro"] == 1} onChange={(e) => this.onCheckChange(e,"cro")}>CRO</Checkbox>
                            <Checkbox checked={checkBoxArr["lineOfBusiness"] == 1} onChange={(e) => this.onCheckChange(e,"lineOfBusiness")}>业务线</Checkbox>
                            <Checkbox checked={checkBoxArr["secondLineName"] == 1} onChange={(e) => this.onCheckChange(e,"secondLineName")}>执行业务线二级分类</Checkbox>
                            <Checkbox checked={checkBoxArr["invNature"] == 1} onChange={(e) => this.onCheckChange(e,"invNature")}>项目性质</Checkbox>
                            <Checkbox checked={checkBoxArr["contractTypeName"] == 1} onChange={(e) => this.onCheckChange(e,"contractTypeName")}>计收入确认方式</Checkbox>
                            <Checkbox checked={checkBoxArr["investigationContractAmount"] == 1} onChange={(e) => this.onCheckChange(e,"investigationContractAmount")}>合同额含税/人民币(元)</Checkbox>
                            <Checkbox checked={checkBoxArr["pm"] == 1} onChange={(e) => this.onCheckChange(e,"pm")}>PM</Checkbox>
                            <Checkbox checked={checkBoxArr["pml"] == 1} onChange={(e) => this.onCheckChange(e,"pml")}>PML</Checkbox>
                            <Checkbox checked={checkBoxArr["pmlLeader"] == 1} onChange={(e) => this.onCheckChange(e,"pmlLeader")}>PML上级</Checkbox>
                            <Checkbox checked={checkBoxArr["planSiteCount"] == 1} onChange={(e) => this.onCheckChange(e,"planSiteCount")}>津石计划负责中心数量</Checkbox>
                            <Checkbox checked={checkBoxArr["siteCount"] == 1} onChange={(e) => this.onCheckChange(e,"siteCount")}>实际中心数</Checkbox>
                            <Checkbox checked={checkBoxArr["typeInformedPlan"] == 1} onChange={(e) => this.onCheckChange(e,"typeInformedPlan")}>津石计划知情数量</Checkbox>
                            <Checkbox checked={checkBoxArr["typeInformedStatistic"] == 1} onChange={(e) => this.onCheckChange(e,"typeInformedStatistic")}>实际知情数</Checkbox>
                            <Checkbox checked={checkBoxArr["typeFilterPlan"] == 1} onChange={(e) => this.onCheckChange(e,"typeFilterPlan")}>津石计划筛选数量</Checkbox>
                            <Checkbox checked={checkBoxArr["typeFilterStatistic"] == 1} onChange={(e) => this.onCheckChange(e,"typeFilterStatistic")}>实际筛选数</Checkbox>
                            <Checkbox checked={checkBoxArr["typeRandomPlan"] == 1} onChange={(e) => this.onCheckChange(e,"typeRandomPlan")}>津石计划随机(入组)数量</Checkbox>
                            <Checkbox checked={checkBoxArr["typeRandomStatistic"] == 1} onChange={(e) => this.onCheckChange(e,"typeRandomStatistic")}>实际随机(入组)数</Checkbox>
                        </div>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default ConfigColumn;



// WEBPACK FOOTER //
// ./src/components/investigation/ConfigColumn.js